import React, { useState } from "react";
import { Loader2, Lock, Pencil } from "lucide-react";
import { api, apiError } from "../lib/api";
import { fmtDateTime } from "../lib/format";
import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { Textarea } from "./ui/textarea";

/** The office's own note on a rental: never in the contract, documents or a driver's view. */
export default function InternalNote({ rental, mayEdit, onSaved }) {
  const [draft, setDraft] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (!mayEdit && !rental.internal_note) return null;

  const save = async () => {
    setBusy(true); setError("");
    try {
      const { data } = await api.put(`/rentals/${rental.id}/internal-note`, { internal_note: draft, expected_note_at: rental.internal_note_at || "" });
      setDraft(null);
      onSaved(data);
    } catch (e) {
      setError(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="space-y-3 p-5" data-testid="internal-note">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="flex items-center gap-2 text-lg font-semibold"><Lock className="h-4 w-4 text-muted-foreground" aria-hidden="true" />Nota interna</h2>
        {mayEdit && draft === null && <Button size="sm" variant="outline" onClick={() => setDraft(rental.internal_note || "")} data-testid="internal-note-edit"><Pencil aria-hidden="true" />{rental.internal_note ? "Modifica" : "Scrivi una nota"}</Button>}
      </div>
      <p className="text-xs text-muted-foreground">Solo per l'ufficio: non compare nel contratto, nei documenti né all'autista.</p>
      {draft === null ? (
        rental.internal_note
          ? <><p className="whitespace-pre-wrap break-words">{rental.internal_note}</p>
            {rental.internal_note_at && <p className="text-xs text-muted-foreground">{rental.internal_note_by_name || "Utente"}, {fmtDateTime(rental.internal_note_at)}</p>}</>
          : <p className="text-sm text-muted-foreground">Nessuna nota.</p>
      ) : (
        <>
          <Textarea aria-label="Nota interna" rows={4} maxLength={5000} value={draft} disabled={busy} onChange={(e) => setDraft(e.target.value)} data-testid="internal-note-text" />
          {error && <p role="alert" className="text-sm text-red-300">{error}</p>}
          <div className="flex justify-end gap-2">
            <Button size="sm" variant="outline" disabled={busy} onClick={() => { setDraft(null); setError(""); }}>Annulla</Button>
            <Button size="sm" disabled={busy} onClick={save} data-testid="internal-note-save">{busy && <Loader2 className="animate-spin" aria-hidden="true" />}Salva nota</Button>
          </div>
        </>
      )}
    </Card>
  );
}
